const Prop65Dialog4i = function () {
	let prop65ProdID,

	init = () => {
		prop65ProdID = prodID;
		
		const prop65Dialog = new Dialog4i();
		const prop65Content = '<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading prop 65 information, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
		prop65Dialog.Init({
			triggerElements: document.querySelector('.prop65'),
			dialogClass: "smallDialog", 
			title: "Prop 65 Warning Information", 
			content: prop65Content, 
			onOpen: getPropSixtyFive
		});	
	},
	getPropSixtyFive = e => {
		fetch('/productmvc/prop65', {
			method: 'POST',
			body: JSON.stringify(prop65ProdID),
			headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
		}).then(function (response) {
			return (response.ok) ? response.text() : []; // response.text() returns a promise
		}).then(function (response) {
			document.getElementById("popUpDialog").querySelector(".dialogContent").innerHTML = response;
		}).catch(function (response) {
			document.getElementById("popUpDialog").querySelector(".dialogContent").innerHTML = "<p class='text16'>There was an issue loading the warnings, please refresh the page and try again.</p>";
		});
	};
	return {
		Init: init 
	};
};

(function(){
	const prop65Dialog = new Prop65Dialog4i();
	prop65Dialog.Init();
})();